export const getPenalty = [
    { value: "No Penalty", id: 1 },
    { value: "Full Amount", id: 2 },
    { value: "Percentage", id: 3 },
    { value: "Fixed Amount", id: 4 },
  ];

 
  export const addDayAvail = [
    { value: "No Show", id: 1 },
    { value: "1 Day", id: 2 },
    { value: "2 Days", id: 3 },
    { value: "3 Days", id: 4 },
    { value: "4 Days", id: 5 },
    { value: "5 Days", id: 6 },
    { value: "6 Days", id: 7 },
    { value: "7 Days", id: 8 },
    { value: "8 Days", id: 9 },
    { value: "9 Days", id: 10 },
    { value: "10 Days", id: 11 },
    { value: "11 Days", id: 12 },
    { value: "12 Days", id: 13 },
    { value: "13 Days", id: 14 },
    { value: "14 Days", id: 15 },
    { value: "15 Days", id: 16 },
    { value: "30 Days", id: 31 },
    { value: "45 Days", id: 46 },
    { value: "60 Days", id: 61 },
  ];

 